// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IYpY","content":"styles_content__3vq08"};